






















































































































































































































































import Vue from "vue";
import {
  DateTimeInterface,
  ModInterface,
  ModpackInterface,
  SlotAvailability,
} from "@/types";
import moment from "moment-timezone";
import FileDownload from "js-file-download";
import Discord from "@/Discord";
import Event from "@/classes/Event";
import User from "@/User";
import EventBriefing from "./EventBriefing.vue";
import EventSlotting from "./EventSlotting.vue";
import EventMods from "./EventMods.vue";
import EventAAR from "./EventAAR.vue";
import UserAvatar from "@/components/users/UserAvatar.vue";

const tabHashes = ["#briefing", "#slotting", "#mods", "#aar"];

export default Vue.extend({
  components: {
    EventBriefing,
    EventSlotting,
    EventMods,
    EventAAR,
    UserAvatar,
  },
  data() {
    return {
      image: "",
      admin: false,
      localMainEvent: false,
      activeTab: 0,
      approvalDialog: false,
      checkAll: false,
      approvalChecks: [
        { label: "Mission is tested", checked: false },
        { label: "No current or recent conflicts", checked: false },
        { label: "Enough slots for players", checked: false },
        { label: "Every squad has clear leadership", checked: false },
        { label: "Special equipment and vehicles are described", checked: false },
      ],
    };
  },
  props: {
    event: {
      type: Object as () => Event & SlotAvailability,
      required: true,
    },
  },
  watch: {
    "$route.hash": {
      handler(hash: string) {
        const tab = tabHashes.indexOf(hash);
        if (tab !== -1 && (tab !== 3 || this.eventHasFinished())) {
          this.activeTab = tab;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    if (this.event.image) {
      const image = await Event.getEventImage(this.event.id);
      this.image = image;
    }
    this.admin = await User.isModerator();
    // initialize local state for the main-event switch
    this.localMainEvent = !!this.event.mainEvent;
  },
  computed: {
    eventDate(): DateTimeInterface {
      return this.event.date as DateTimeInterface;
    },
    utcDate(): moment.Moment | undefined {
      if (!this.formattedDate || !this.eventDate || !this.eventDate.timezone) {
        return;
      }
      return moment.tz(this.formattedDate, this.eventDate.timezone);
    },
    localDate(): string {
      if (!this.utcDate) {
        return "";
      }
      return this.utcDate
        .clone()
        .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
        .format("dddd, MMMM Do YYYY, HHmm [hours]");
    },
    formattedDate(): string {
      return this.event.date ? this.eventDate.date.substring(0, 23) : "";
    },
    modpack(): ModpackInterface {
      return this.event.modpack as ModpackInterface;
    },
    mods(): ModInterface[] {
      if (this.event.modpack) {
        return this.modpack.mods;
      }

      return [];
    },
    meanRating(): number {
      if (!this.event.ratings || this.event.ratings.length === 0) {
        return 0;
      }
      const sum = this.event.ratings.reduce((acc: number, rating: any) => acc + rating.rating, 0);
      return sum / this.event.ratings.length;
    },
    allChecked(): boolean {
      return this.approvalChecks.every((c: any) => c.checked);
    },
  },
  methods: {
    isAdmin(): boolean {
      return this.admin;
    },
    onTabChange(tab: number) {
      const hash = tabHashes[tab];
      if (hash !== undefined && this.$route.hash !== hash) {
        this.$router.push({ hash }).catch(() => undefined);
      }
    },
    eventHasStarted(): boolean {
      if (this.utcDate === undefined) {
        return false;
      }
      return this.utcDate.diff(moment()) < 0;
    },
    eventHasFinished(): boolean {
      return this.event.finished;
    },
    eventHasPassed(): boolean {
      const eventDate = moment.utc(this.event.date.date);
      const today = moment.utc();
      return moment.utc(today).isAfter(eventDate);
    },
    async finishEvent() {
      await this.axios.patch(`/arma/events/${this.event.id}`, {
        finished: 1,
      });
      this.$router.push("/events");
    },
    async downloadCalendarFile() {
      const response = await this.axios({
        url: "arma/events/" + this.event.id,
        method: "GET",
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
        },
      });

      FileDownload(response.data, this.event.name + ".ics");
    },

    getAvatar(id: number, avatar: string) {
      return Discord.avatarSourceUri(id, avatar);
    },

    onCheckAll(val: boolean) {
      this.approvalChecks.forEach((c) => (c.checked = val));
    },
    syncCheckAll() {
      this.checkAll = this.approvalChecks.every((c) => c.checked);
    },
    async submitApproval() {
      this.approvalDialog = false;
      await this.approveEvent();
    },
    async approveEvent() {
      const user = User.get()!;
      await this.axios.patch(`/arma/events/${this.event.id}`, {
        approved: true,
        moderator: user.id,
        mainEvent: this.localMainEvent,
      });
      this.$router.push("/events");
    },
    async toggleMainEvent() {
      // Patch the event's mainEvent flag on the server
      await this.axios.patch(`/arma/events/${this.event.id}`, {
        mainEvent: this.localMainEvent,
      });
      // let parent/listeners refresh the event
      this.$emit("reload-event");
    },

    async deleteEvent() {
      await this.axios.delete(`/arma/events/${this.event.id}`);
      this.$router.push("/events");
    },

    async getEventImage() {
      return await Event.getEventImage(this.event.id);
    },

    handleAvatarError(e: any) {
      const target = e.target as HTMLImageElement;
      // Set a placeholder avatar using a generic Discord default avatar
      target.src = "https://cdn.discordapp.com/embed/avatars/0.png";
    },
  },
});
